import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Access from "constants/Access";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import UniversalModalOverride from "components/UniversalModalOverride";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'My FFL Dealers',
		url: '/dealers',
		icon: 'suitcase',
	},
];

export default class Dealer extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}

	startTransaction = async (transactionType) => {
		this.setState({startingTransaction: true});
		try {
			const dealerModel = new API.BuildClass(Types.Dealers._name, API.RequestType.READ);
			dealerModel.object.pkey = this.props.match.params.id;
			const dealer = await dealerModel.submit(null, API.RequestType.READ);
			if (!dealer || !dealer.pkey || !dealer.binary_id) {
				throw new Error('Dealer unavailable');
			}
			this.setState({transactionDealer: dealer, transactionType});
		} catch (error) {
			API.Toast.error('Unable to load this dealer. Please try again.');
		} finally {
			this.setState({startingTransaction: false});
		}
	};

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/dealers/${this.props.id}`,
				icon: 'suitcase',
			}
		]);
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Button data-id="start-dealer-acquisition" size="sm" color="primary"
						disabled={this.state.startingTransaction} onClick={() => this.startTransaction('acquisition')}>
						<i className="fa fa-download"/>&nbsp;&nbsp;Start Acquisition
					</Button>{' '}
					<Button data-id="start-dealer-transfer" size="sm" color="primary"
						disabled={this.state.startingTransaction} onClick={() => this.startTransaction('transfer')}>
						<i className="fa fa-random"/>&nbsp;&nbsp;Start Transfer
					</Button>
				</Framework.Components.PageBar>

				{this.state.transactionType && <UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					name={this.state.transactionType === 'acquisition' ? 'Acquisition' : 'Transfer'}
					object={this.state.transactionType === 'acquisition' ? Objects.Acquisition : Objects.Transfer}
					showModal={true}
					reportClose={() => this.setState({transactionType: null, transactionDealer: null})}
					afterSave={() => this.refreshPage()}
					size="xl"
					objectProps={{initialDealer: this.state.transactionDealer}}
				/>}

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Dealer" value="details"/>
					{this.props.userAccess <= Access.Manager && <Tab label="Change Log" value="logs"/>}
					<Tab label="Possible Duplicate" value="duplicates"/>
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.Dealer
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						baseUrl={this.props.baseUrl}
					/>
				</div>
				{this.state.tab === 'logs' && this.props.userAccess <Access.Supervisor &&
				<Collections.LogsDealers
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'duplicates' &&
				<Collections.DealerDuplicates
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
			</div>
		)
	}
};